module.exports = __webpack_public_path__ + "img/ARCH_03_prew.d95c6884.jpg";